enum PacienteActionTypes {
  LOADING = 'paciente/LOADING',
  LOADED = 'paciente/LOADED',
  FAILED = 'paciente/FAILED',
  CLEAR = 'paciente/CLEAR',
  BIOMETRICS = 'paciente/BIOMETRICS'
}

export default PacienteActionTypes;
